import React from "react";
import { AppVersionNameCellTemplate } from "themes/administration/app-release/components";

function AppVersionNameCell(props) {
    return <AppVersionNameCellTemplate {...props} />;
}

export default AppVersionNameCell;
